import React from 'react'
import { connect } from 'react-redux'
import injectSheet from 'react-jss'
import style from './style'
import { createProjectAction } from 'actions/projectActions'

class NewProjectAtLocation extends React.Component {
  acceptButtonClicked = (close, createProjectAction) => {
    close()
    createProjectAction()
  }

  render() {
    const { props: { classes, close, createProjectAction }, acceptButtonClicked } = this

    return (
      <div>
        <p>You searched for a new location, but already have edited this project. Would you like to create a new project at this location instead?</p>
        <div className={classes.buttonContainer}>
          <button
            className={classes.confirmButton}
            onClick={acceptButtonClicked.bind(null, close, createProjectAction)}
          >
            Yes, Create New Project
          </button>
          <button
            className={classes.rejectButton}
            onClick={close}
          >
            No, Remain with Current Project
          </button>
        </div>
      </div>
    )
  }
}

export const NewProjectAtLocationConfig = { title: 'Create New Project at Search Location?' }
export default connect(null, { createProjectAction })(injectSheet(style)(NewProjectAtLocation))



// WEBPACK FOOTER //
// ./src/components/NewProjectAtLocation/index.js